import React, { useEffect } from 'react';
import { Product } from '../types';

interface ProductSchemaProps {
  product: Product;
}

const ProductSchema: React.FC<ProductSchemaProps> = ({ product }) => {
  useEffect(() => {
    // Create base offer structure
    const baseOffer = {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "seller": {
        "@type": "Organization",
        "name": "festutrustning.se",
        "url": "https://festutrustning.se"
      },
      "areaServed": {
        "@type": "AdministrativeArea",
        "name": "Skåne län"
      }
    };

    // Add price information only if not quote-based
    let offerData;
    if (product.priceOnRequest) {
      offerData = {
        ...baseOffer,
        "priceSpecification": {
          "@type": "PriceSpecification",
          "priceCurrency": "SEK",
          "valueAddedTaxIncluded": "https://schema.org/False"
        }
      };
    } else {
      offerData = {
        ...baseOffer,
        "price": product.pricePerDay,
        "priceCurrency": "SEK",
        "priceValidUntil": new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
        "priceSpecification": {
          "@type": "UnitPriceSpecification",
          "price": product.pricePerDay,
          "priceCurrency": "SEK",
          "unitText": "per dag"
        }
      };
    }

    // Create the schema
    const schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": product.name,
      "description": product.description,
      "image": [product.image, ...(product.gallery || [])],
      "brand": {
        "@type": "Brand",
        "name": "festutrustning.se"
      },
      "category": product.category,
      "offers": offerData,
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "5.0",
        "bestRating": "5",
        "worstRating": "1",
        "reviewCount": "15",
      },
      "review": [
        {
          "@type": "Review",
          "datePublished": "2024-12-15",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "Anna Andersson"
          },
          "reviewBody": "Fantastisk utrustning och professionell service. Allt fungerade perfekt på vårt bröllop!"
        },
        {
          "@type": "Review",
          "datePublished": "2024-11-28",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "Erik Johansson"
          },
          "reviewBody": "Mycket nöjd med ljudkvaliteten och den enkla installationen. Rekommenderar starkt!"
        }
      ]
    };

    // Add the schema to the page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    // Clean up
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(s => {
        try {
          const data = JSON.parse(s.textContent || '{}');
          if (data['@type'] === 'Product' && data.name === product.name) {
            s.remove();
          }
        } catch (e) {
          // Ignore parsing errors
        }
      });
    };
  }, [product]);

  return null;
};

export default ProductSchema;